import ky from 'ky';

// Normaliza la URL base y elimina barras finales para evitar "//api"
const API_BASE_URL = (process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8080').replace(/\/+$/, '');

// Función helper para obtener la URL base del API
export const getApiBaseUrl = () => API_BASE_URL;

// Cliente general sin autenticación
export const api = ky.create({
  prefixUrl: API_BASE_URL,
  credentials: 'include',
  timeout: 150000,
  retry: {
    limit: 1,
    methods: ['get'],
    statusCodes: [408, 502, 503, 504],
  },
  hooks: {
    beforeRequest: [
      (request) => {
        request.headers.set('Content-Type', 'application/json');
      },
    ],
  },
});

// Cliente API con JWT en headers para autenticación
export const apiWithAuth = ky.create({
  prefixUrl: API_BASE_URL,
  credentials: 'include',
  timeout: 150000,
  retry: {
    limit: 1,
    methods: ['get'],
    statusCodes: [408, 502, 503, 504],
  },
  hooks: {
    beforeRequest: [
      (request) => {
        request.headers.set('Content-Type', 'application/json');

        const token = localStorage.getItem('abbi_token');
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      },
    ],
    afterResponse: [
      (_request, _options, response) => {
        // Si el backend retorna 401, la sesión expiró o fue cerrada
        if (response.status === 401) {
          // Limpiar token y redirigir a login
          localStorage.removeItem('abbi_token');
          // Evitar múltiples redirecciones si ya estamos en login
          if (typeof window !== 'undefined' && !window.location.pathname.includes('/login')) {
            window.location.href = '/login?expired=1';
          }
        }
        return response;
      },
    ],
  },
});
